/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { ReactElement } from 'react';
import { Tooltip } from '@mui/material';

interface DiviNavigationSymbolProps {
  tooltip: string;
  children: ReactElement;
}

export function DiviNavigationSymbol({ tooltip, children }: DiviNavigationSymbolProps) {
  return (
    <Tooltip
      title={tooltip}
      disableInteractive
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}>
      <span className='divi-navigation-symbol-overlay'>{children}</span>
    </Tooltip>
  );
}
